import React, { Component } from "react";
import { connect } from "react-redux";
import { parseString } from "xml2js";
import _ from "lodash";
import { Table } from "semantic-ui-react";
import { expireSession } from "../../actions/auth";
import api from "../../api";
import settings from "../../settings";
import { getErrorMessage } from "../messages/errorMessages";
import {getErrorNode} from "../../utils/errorUtil";

class CurrentCases extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      userCode: undefined,
      errorNode: undefined
    };
  }

  componentDidMount() {
    this.loadCaseCharges(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.loadCaseCharges(nextProps);
  }

  componentWillUnmount() {
    this.isCompMounted = false;
  }

  isCompMounted = false;

  handleEditCase = (folderCode, folderName, comment) => {
    const currentCase = { folderCode, folderName, comment };
    this.props.editCase(currentCase);
  };

  loadCaseCharges = (props) => {
    const userCode =
      props.pickuser && props.pickuser !== ""
        ? props.pickuser
        : props.user.userid;
    this.isCompMounted = true;
    props.onLoadStart();
    const params = {
      view: "current",
      sserver: settings.appName,
      userID: props.user.userid,
      pickedUser: props.pickuser,
      sessionID: localStorage.getItem("sessionID"),
    };
    api.lp
      .getActivitiesView(params)
      .then((res) => {
        parseString(res.data, { async: false }, (err, result) => {
            if(result == null) {
                const errorNode = getErrorNode();
                this.setState({ errorNode });
                return;
            }	
          const root = Object.keys(result)[0];
          if (root === "errors") {
            if (
              _.get(result, `${root}.error[0].$.errType`) === "unauthorized"
            ) {
              localStorage.errorMessage = _.get(
                result,
                `${root}.error[0].errMsg[0]`,
                ""
              );
              const errorMessage = getErrorMessage(
                localStorage.errorMessage,
                _.get(result, `${root}.error[0].errMsg[0]`, "")
              );
              this.props.expireSession(errorMessage);
            }
          } else {
            const rows = [];
            const folders = _.get(result, "folders.folder");
            if (folders !== undefined) {
              _.forEach(folders, (folder, index) => {
                const folderName = _.get(folder, "folderName[0]");
                const folderCode = _.get(folder, "folderCode[0]");
                const comment = _.get(folder, "comment[0]");
                rows.push(
                  <Table.Row key={`case_row_${index}`}>
                    <Table.Cell>
                      <div
                        role="link"
                        tabIndex={0}
                        onClick={() =>
                          this.handleEditCase(folderCode, folderName, comment)
                        }
                        className={"url-link"}
                      >
                        {_.get(folder, "folderName[0]")}
                      </div>
                    </Table.Cell>
                    <Table.Cell>{_.get(folder, "comment[0]")}</Table.Cell>
                    <Table.Cell>
                      {_.get(folder, "actUpdateFormatted[0]")}
                    </Table.Cell>
                  </Table.Row>
                );
              });
            }
            if (this.isCompMounted) {
              this.setState({ rows, userCode });
            }
          }
          props.onLoadComplete();
        });
      })
      .catch((err) => console.log("load case charges error - ", err));
  };

  render() {
    const {errorNode} = this.state;
    if(errorNode !== undefined) return errorNode;
    return (
      <Table>
        <Table.Body>
          <Table.Row className="report-section-header">
            <Table.HeaderCell>Case Name</Table.HeaderCell>
            <Table.HeaderCell>Comments</Table.HeaderCell>
            <Table.HeaderCell>Updated</Table.HeaderCell>
          </Table.Row>
          {this.state.rows}
        </Table.Body>
      </Table>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

export default connect(mapStateToProps, { expireSession })(CurrentCases);



// WEBPACK FOOTER //
// ./src/components/myaccount/CurrentCases.js